import Page from './manage-contact.page'

let routes = [
  {
    path: 'manage-contact',
    name: 'manage-contact',
    component: Page
  }
]

export default routes

